// @flow

export const isNZHelix = (): boolean =>
  process.env.REACT_APP_DATA_ENDPOINT === 'nz-helix' ||
  window.location.host.includes('nz')
    ? true
    : false;

export const getHelixBaseUrl = (country: string): string => {
  if (country === "nz") {
    return 'nzhelix.roymorgan.com';
  }
  return 'helix.roymorgan.com';
};
